document.addEventListener('DOMContentLoaded', function () {

  // =====================================
  // Calculator Elements
  // =====================================

  const peptideMg = document.getElementById('peptideMg');
  const bacWater = document.getElementById('bacWater');
  const targetDose = document.getElementById('targetDose');

  const drawUnits = document.getElementById('drawUnits');
  const volumeResult = document.getElementById('volumeResult');
  const concentrationResult = document.getElementById('concentrationResult');
  const dosesPerVial = document.getElementById('dosesPerVial');

  const syringeFill = document.getElementById('syringeFill');
  const stickyUnits = document.getElementById('stickyUnits');

  // =====================================
  // Calculator Function
  // =====================================

  function calculate() {

    if (
      !peptideMg ||
      !bacWater ||
      !targetDose ||
      !drawUnits ||
      !volumeResult ||
      !concentrationResult ||
      !dosesPerVial
    ) {
      return;
    }

    const mg = parseFloat(peptideMg.value) || 0;
    const water = parseFloat(bacWater.value) || 0;
    const dose = parseFloat(targetDose.value) || 0;

    if (mg <= 0 || water <= 0 || dose <= 0) {
      return;
    }

    // mcg/ml concentration
    const concentration = (mg * 1000) / water;

    // required volume
    const volume = dose / concentration;

    // U100 units
    const units = volume * 100;

    // doses per vial
    const totalDoses = Math.floor((mg * 1000) / dose);

    drawUnits.textContent =
      units.toFixed(1) + ' Units';

    volumeResult.textContent =
      volume.toFixed(3) + ' mL';

    concentrationResult.textContent =
      concentration.toLocaleString() + ' mcg/mL';

    dosesPerVial.textContent =
      totalDoses;

    if (syringeFill) {

      const fillPercentage =
        Math.min(units, 100);

      syringeFill.style.width =
        fillPercentage + '%';

    }

    if (stickyUnits) {

      stickyUnits.textContent =
        units.toFixed(1) + ' Units';

    }

  }

  // =====================================
  // Input Events
  // =====================================

  [peptideMg, bacWater, targetDose]
    .filter(Boolean)
    .forEach(input => {

      input.addEventListener(
        'input',
        calculate
      );

    });

  // =====================================
  // Dose Presets
  // =====================================

  document
    .querySelectorAll('.dose-preset')
    .forEach(button => {

      button.addEventListener('click', () => {

        targetDose.value =
          button.dataset.dose;

        calculate();

      });

    });

  // =====================================
  // Product Presets
  // =====================================

  document
    .querySelectorAll('.product-preset')
    .forEach(button => {

      button.addEventListener('click', () => {

        if (peptideMg) {
          peptideMg.value =
            button.dataset.mg;
        }

        if (bacWater) {
          bacWater.value =
            button.dataset.water;
        }

        if (
          targetDose &&
          button.dataset.dose
        ) {

          targetDose.value =
            button.dataset.dose;

        }

        calculate();

      });

    });

  // =====================================
  // Copy Result Button
  // =====================================

  const copyButton =
    document.getElementById('copyResult');

  if (copyButton) {

    copyButton.addEventListener('click', () => {

      const copyText =
        `Draw ${drawUnits.textContent} (${volumeResult.textContent})`;

      navigator.clipboard.writeText(copyText);

      copyButton.textContent =
        'Copied ✓';

      setTimeout(() => {

        copyButton.textContent =
          'Copy Result';

      }, 2000);

    });

  }

  // =====================================
  // Review Carousel
  // =====================================

  const reviewSlides =
    document.querySelectorAll('.review-slide');

  const nextButton =
    document.querySelector('.next-review');

  const prevButton =
    document.querySelector('.prev-review');

  let currentReview = 0;
  let autoPlay;

  function showReview(index) {

    reviewSlides.forEach(slide => {
      slide.classList.remove('active');
    });

    if (reviewSlides[index]) {
      reviewSlides[index]
        .classList.add('active');
    }

  }

  function nextReview() {

    currentReview++;

    if (
      currentReview >= reviewSlides.length
    ) {
      currentReview = 0;
    }

    showReview(currentReview);

  }

  function prevReview() {

    currentReview--;

    if (currentReview < 0) {
      currentReview =
        reviewSlides.length - 1;
    }

    showReview(currentReview);

  }

  function startAutoPlay() {

    if (reviewSlides.length <= 1) {
      return;
    }

    autoPlay = setInterval(() => {

      nextReview();

    }, 5000);

  }

  function resetAutoPlay() {

    clearInterval(autoPlay);

    startAutoPlay();

  }

  if (reviewSlides.length) {

    showReview(0);

    startAutoPlay();

  }

  if (nextButton) {

    nextButton.addEventListener(
      'click',
      () => {

        nextReview();

        resetAutoPlay();

      }
    );

  }

  if (prevButton) {

    prevButton.addEventListener(
      'click',
      () => {

        prevReview();

        resetAutoPlay();

      }
    );

  }

  // =====================================
  // Initialize Calculator
  // =====================================

  calculate();

});